import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spinner, Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import Block from '../common/Display/Block';
import SectionButton from './SectionButton';
import Translate from '../common/Translate';
import AlertModal from '../common/Modal/AlertModal';
import submitForm from '../../services/Form/submitForm';
import storeForm from '../../services/Form/storeForm';
import getFormLocal, { copyAnswers } from '../../services/Form/getFormLocal';
import getSections from '../../services/Form/getSections';
import getAnswers from '../../services/answers/getFailedAnswers';
import calculateProgress from '../../services/Form/calculateProgress';
import { STATUS as statusList, LOCALSTATUS as localStatusList } from '../../config';

import updateFormStatus from '../../services/Form/updateFormStatus';
import { store } from '../../Store/store';
import { Auth, messenger } from '../../config/configuration/react';
import removeValue from '../../services/Form/removeValue';

const statusToReport = [
  // statusList.appraisal_stopped,
  // statusList.completed,
  statusList.submitted,
  // statusList.report_available,
];

class SectionsList extends Component {
  constructor(props) {
    super(props);
    const { match, location, history } = this.props;
    this.formId = match.params.formId;

    this.state = {
      currentForm: {},
      sections: [],
      modalIsOpen: false,
      message: '',
      progress: {},
      loading: true,
      loadingForSave: false,
      unauthorize: false,
      verifProgress: null,
      answers: [],
      imagesAnswers: [],
    };
    this.queries = undefined;
    this.location = location;
    this.match = match;
    this.history = history;
    if (this.location.state !== undefined && 'queries' in this.location.state) {
      this.queries = this.location.state.queries;
    }
    this._isMounted = false;
  }

  componentDidMount() {
    this.updateForm(this.formId);
    this.updateSection(this.formId);
    this.updateProgress(this.formId);
    this.checkAnswers();
    window.addEventListener('storage', this.checkAnswers);
    setInterval(this.syncLoop, 5000);
  }

  componentWillUnmount() {
    this._isMounted = true;
    window.removeEventListener('storage', this.checkAnswers);
  }

  syncLoop = () => {
    if (!window.navigator.onLine) return;
    const { answers, imagesAnswers } = this.state;
    if (imagesAnswers.length > 0) messenger.sendMessage('syncImages', '');
    if (answers.length > 0) messenger.sendMessage('syncAnswers', this.formId);
  };

  getBackRoute = () => {
    let backRoute = '';
    if (this.queries) {
      if (typeof this.queries === 'string' && this.queries.startsWith('/files/')) backRoute = this.queries;
      else backRoute = this.location.state.from;
    } else backRoute = '/forms';
    return backRoute;
  };

  checkStatus = (form) => {
    const record = _.get(store.getState(), `reduxRecords.data[${form.recordId}].record`, {});
    if (statusToReport.includes(form.status) || record?.statusId === 4) {
      if (!statusToReport.includes(form.status)) updateFormStatus(this.formId, statusList.submitted);
      this.history.push({
        pathname: `/report/${this.formId}`,
        state: { ...this.location.state, queries: this.queries },
      });
    }
  };

  checkUserAutorise = (form) => {
    let buyerId = _.get(store.getState(), `reduxRecords.data[${form.recordId}].expertise.expertiseBuyerId`, null);
    const supervisorId = _.get(
      store.getState(),
      `reduxRecords.data[${form.recordId}].expertise.expertiseSupervisorId`,
      null,
    );
    const buyerName = `${_.get(
      store.getState(),
      `reduxRecords.data[${form.recordId}].expertise.buyerFirstName`,
      null,
    )} ${_.get(store.getState(), `reduxRecords.data[${form.recordId}].expertise.buyerLastName`, null)}`;
    const variable = { buyerName };
    if (supervisorId !== null) {
      buyerId = supervisorId;
    }
    if (Auth.userId() !== buyerId && ![5, 6].includes(Auth.roleId())) {
      this.toggleModal();
      this.setState({ message: ['file_assigned_to', variable] });
      this.setState({ unauthorize: true });
    }
  };

  updateForm = (formId) => {
    this.setState({ loading: true });
    getFormLocal(formId).then((form) => {
      if (this._isMounted) return;
      this.checkStatus(form);
      if (this._isMounted) return;
      copyAnswers(form);
      this.checkUserAutorise(form);
      this.setState({ currentForm: form });
      this.setState({ loading: false });
    });
  };

  updateSection = (formId) => {
    const self = this;
    getSections(formId).then((sections) => {
      if (self._isMounted) return;
      self.setState({ sections });
    });
  };

  checkAnswers = () => {
    const self = this;
    getAnswers(this.formId).then((answers) => {
      if (self._isMounted) return;
      self.setState({ answers: answers?.answers || [], imagesAnswers: answers?.images || [] });
    });
  };

  handleClick = async () => {
    if (!window.navigator.onLine) return;
    this.setState({ loadingForSubmit: true });
    await messenger.sendMessage('syncImages', '');
    await messenger.sendMessage('syncAllAnswers', '');
    const res = await submitForm(this.formId);
    const success = res.formFinished ? res.formFinished : false;
    const missingInfos = res.missingField ? res.missingField : null;

    if (!success) {
      this.setState({ message: missingInfos });
      this.setState({ loadingForSubmit: false });
      this.toggleModal();
    } else {
      try {
        await storeForm(this.formId);
        await removeValue(this.formId, 'escape_question');
        await updateFormStatus(this.formId, statusList.completed);
        await updateFormStatus(this.formId, localStatusList.updated, 'localStatus');
        this.history.push({
          pathname: `/report/${this.formId}`,
          state: this.location.state,
        });
      } catch (e) {
        console.log('no network to save form');
      } finally {
        this.setState({ loadingForSubmit: false });
      }
    }
  };

  saveFormClick = async () => {
    this.setState({ loadingForSave: true });
    try {
      await storeForm(this.formId);
    } catch (e) {
      // dispatchAlert(t(e.message), 'danger', t(e.message));
    } finally {
      this.setState({ loadingForSave: false });
    }
    return true;
  };

  toggleModal = () => {
    const { unauthorize } = this.state;
    this.setState((prevState) => ({
      modalIsOpen: !prevState.modalIsOpen,
    }));
    if (unauthorize) {
      this.history.push({
        pathname: this.getBackRoute(),
        state: this.location.state,
      });
    }
  };

  togglePostForm = async () => {
    const updateStatus = await updateFormStatus(this.formId, statusList.appraisal_stopped);
    const updateLocalStatus = await updateFormStatus(this.formId, localStatusList.updated, 'localStatus');
    await storeForm(this.formId, statusList.appraisal_stopped);
    Promise.all([updateStatus, updateLocalStatus]).then(() => {
      this.history.push({
        pathname: `/report/${this.formId}`,
        state: this.location.state,
      });
    });
  };

  updateProgress = (formId) => {
    const self = this;
    calculateProgress(formId).then((progress) => {
      if (self._isMounted) return;
      self.setState(progress);
    });
  };

  render() {
    const {
      loading,
      sections,
      modalIsOpen,
      unauthorize,
      currentForm,
      loadingForSave,
      message,
      loadingForSubmit,
      answers,
      imagesAnswers,
    } = this.state;

    return (
      <Block {...this.props} backRoute={this.getBackRoute()} headerTitle={currentForm.name} showSubHeader>
        <Container fluid className="mt-4">
          <Row>
            {loading && (
              <Col xs="12" className="text-center">
                <Spinner color="primary" />
              </Col>
            )}
          </Row>
          <div className="before-sticky-bottom">
            <Row>
              {sections.map((section) => {
                return (
                  <Col key={section.id} xs="12" md="6" xl="4">
                    <SectionButton
                      formId={this.formId}
                      sectionId={section.id}
                      progress={_.get(this.state, section.id)}
                      lastQuestion={_.get(section, 'lastQuestion', null)}
                    />
                  </Col>
                );
              })}
            </Row>
          </div>
          <div className="footer-sticky-bottom">
            {!modalIsOpen && (
              <Row>
                <SaveButton onClick={this.saveFormClick} loading={loadingForSave} />
                <PostButton
                  onClick={this.handleClick}
                  loading={loadingForSubmit}
                  disabled={answers.length > 0 || imagesAnswers.length > 0}
                  // progress={this.state.verifProgress}
                />
              </Row>
            )}
          </div>
          {(!unauthorize && (
            <Row>
              <Col xs="12" className="mt-3 text-center">
                <AlertModal
                  isOpen={modalIsOpen}
                  onClose={this.toggleModal}
                  centered
                  message={message}
                  addNewBtn
                  formId={this.formId}
                  togglePostForm={this.togglePostForm}
                  title="form_not_complete_message"
                />
              </Col>
            </Row>
          )) || (
            <AlertModal
              isOpen={modalIsOpen}
              onClose={this.toggleModal}
              centered
              message={message}
              formId={this.formId}
              title="edit_forbidden"
            />
          )}
        </Container>
      </Block>
    );
  }
}

export default SectionsList;

SectionsList.propTypes = {
  match: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
};

function PostButton({ onClick, disabled, loading }) {
  return (
    <Col>
      <button
        type="button"
        className="btn btn-block btn-1"
        data-test="submitForm-btn"
        onClick={onClick}
        data-cy="submitForm"
        disabled={disabled}
      >
        <Translate code="submit" />
        {disabled && !window.navigator.onLine && (
          <span className="float-right">
            <FontAwesomeIcon icon={faTimesCircle} />
            no_signal
          </span>
        )}
        {((disabled && window.navigator.onLine) || loading) && <Spinner size="sm" />}
      </button>
    </Col>
  );
}

PostButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

function SaveButton({ onClick, loading }) {
  return (
    <Col>
      <button
        type="button"
        className="btn btn-block btn-3"
        onClick={onClick}
        data-cy="saveForm"
        data-test="saveForm-btn"
      >
        <Translate code="save_form" /> {loading && <Spinner color="white ml-2" size="sm" />}
      </button>
    </Col>
  );
}

SaveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
